import { render, staticRenderFns } from "./PrintMelli.vue?vue&type=template&id=10af3006&scoped=true"
import script from "./PrintMelli.vue?vue&type=script&lang=js"
export * from "./PrintMelli.vue?vue&type=script&lang=js"
import style0 from "./PrintMelli.vue?vue&type=style&index=0&id=10af3006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af3006",
  null
  
)

export default component.exports